import { render, staticRenderFns } from "./SuggestionsImprovementsTable.vue?vue&type=template&id=5e81f76a&scoped=true&"
import script from "./SuggestionsImprovementsTable.vue?vue&type=script&lang=js&"
export * from "./SuggestionsImprovementsTable.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionsImprovementsTable.vue?vue&type=style&index=0&id=5e81f76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e81f76a",
  null
  
)

export default component.exports